import React from "react";

import { OTPInput } from "@/components/ui/OTPInput";
import { EnrollMfaResponse } from "@/queries/auth/mfa/types";
import LoadingSpinner from "@/components/LoadingSpinner";

interface QrCodeStepProps {
  enrollmentData: EnrollMfaResponse | null;
  isEnrolling: boolean;
}

export const QrCodeStep: React.FC<QrCodeStepProps> = ({ enrollmentData, isEnrolling }) => {
  const renderContent = () => {
    if (isEnrolling) {
      return <LoadingSpinner size={4} />;
    }

    if (!enrollmentData) {
      return <p className="text-sm text-gray-600">We'll generate a QR code for you to scan</p>;
    }

    return (
      <>
        {enrollmentData.qr_code && (
          <div className="rounded-lg border border-gray-200 bg-white p-4">
            <img src={enrollmentData.qr_code} alt="MFA QR Code" className="h-64 w-64" />
          </div>
        )}
        {enrollmentData.secret && (
          <div className="w-full rounded-lg border border-gray-200 bg-gray-50 p-4">
            <p className="mb-2 text-sm font-medium text-gray-700">Manual Entry Secret:</p>
            <p className="font-mono text-sm text-gray-900">{enrollmentData.secret}</p>
          </div>
        )}
        <p className="text-sm text-gray-600">
          Scan this QR code with your authenticator app, then click continue to verify your setup.
        </p>
      </>
    );
  };

  return <div className="flex flex-col items-center gap-4 py-4">{renderContent()}</div>;
};

interface VerificationStepProps {
  verificationCode: string;
  setVerificationCode: (code: string) => void;
  isVerifying: boolean;
}

export const VerificationStep: React.FC<VerificationStepProps> = ({
  verificationCode,
  setVerificationCode,
}) => (
  <div className="mb-4 flex flex-col gap-1">
    <OTPInput
      code={verificationCode}
      setCode={value => setVerificationCode(value)}
      onPaste={value => setVerificationCode(value)}
      errorMessage={undefined}
    />
  </div>
);
